/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Col, Container, FormSelect, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { Button, DropDown, Input } from "../../components";
import { images } from "../../config/images";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllSportsList } from "../../redux/Slice/Sports/SportsListSlice";
import { AllCoachesList } from "../../redux/Slice/Coaches/CoachesListSlice";
import { CreateNewSession } from "../../utilities/api/sports/indext";
import { SessionDetailType, SessionSlotType } from "../../utilities/types";
import { toast } from "react-toastify";
import "./CreateSession.css";
import _uniqWith from "lodash/uniqWith";
import {
  validatePositiveValue,
  numberValidation,
} from "../../utilities/utils";
import { countWeeks } from "./session.utils";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { GetAvailableCourtForSession } from "../../utilities/api/courts";
import { TIME_OPTIONS, WEEK_DAYS } from "../../utilities/utils"
import { messages } from "../../utilities/Messages";


const errorInit = {
  name: "",
  startDate: "",
  slot: "",
  rule: [],
  rates: "",
  maxNoOfAttendees: "",
  minWeeksToBook: "",
  courts: "",
  coachId: "",
  sportId: "",
};


export const WeekOptions = [
  { label: "2 Sessions per week", value: 2 },
  { label: "3 Sessions per week", value: 3 },
  { label: "4 Sessions per week", value: 4 },
  { label: "5 Sessions per week", value: 5 },
  { label: "6 Sessions per week", value: 6 },
  { label: "7 Sessions per week", value: 7 },
];



const CreateSession = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { AllSportsData, sportErrorMessage } = useAppSelector((state) => state.sportList);
  const { AllCoachesData, errorMessage } = useAppSelector((state) => state.coachList);
  const { SelectedFacility = "" } = useAppSelector(
    (state) => state.facilityList
  );

  if (errorMessage || sportErrorMessage) {
    toast.error(errorMessage.message)
  }

  const [session, setSession] = useState<SessionDetailType>({
    name: "",
    sportId: 0,
    coachId: 0,
    courts: [],
    startDate: "",
    endDate: "",
    minWeeksToBook: "",
    maxNoOfAttendees: "",
    slots: [],
    rules: [
      {
        subject: "",
        description: "",
      },
    ],
    rates: [],
    offers: [],
  });
  const [error, setError] = useState({ ...errorInit });
  const [maxNumberOfWeeks, setMaxNumberOfWeeks] = useState<any>(null);
  const [currentSessionSlot, setCurrentSessionSlot] = useState<SessionSlotType>(
    {
      sessionDay: "",
      startTime: "",
      endTime: "",
    }
  );
  const [rates, setRates] = useState({
    noOfDays: "",
    ratePerSession: "",
  });
  const [offers, setOffers] = useState({
    discountPercent: "",
    noOfWeeks: "",
  });
  const [offersError, setOffersError] = useState({
    discountPercent: "",
    noOfWeeks: "",
  });
  const [endTime, setEndTime] = useState<string[]>([]);
  const [courtList, setCourtList] = useState<any>([]);
  const [submitButton, setSubmitButton] = useState(false);
  const [rateError, setRateError] = useState("");
  const getMessage = messages.coaching;

  useEffect(() => {
    if (!SelectedFacility) {
      toast.error(getMessage.facility_isNotEmpty);
    }
    updateSessionValue("sportId", 0);
    dispatch(AllSportsList({ facilityId: SelectedFacility, isActive: "true" }));
    dispatch(AllCoachesList());
  }, [SelectedFacility]);

  useEffect(() => {
    updateSessionValue("courts", []);
  }, [session?.sportId]);

  const GetCourt = async () => {
    const payload = {
      facilityId: Number(SelectedFacility),
      sportId: session?.sportId,
      startDate: session.startDate
        ? format(new Date(session.startDate), "yyyy-MM-dd")
        : session.startDate,
      endDate: session.endDate
        ? format(new Date(session.endDate), "yyyy-MM-dd")
        : session.endDate,
      slots: session.slots,
      sessionId: "",
    };
    if (session.slots.length && session.startDate && session?.sportId) {
      const result = await GetAvailableCourtForSession(payload);
      if (result.status === 200) {
        setCourtList(result.data.data.rows);
        result.data.data.rows.length === 0 &&
          toast.error(getMessage.court_isNotEmpty);
      } else {
        toast.error(result.response.data.message);
      }
    }
  };

  useEffect(() => {
    GetCourt();
  }, [
    SelectedFacility,
    session?.sportId,
    session.startDate,
    session.endDate,
    session.slots,
  ]);

  useEffect(() => {
    const temp = TIME_OPTIONS.filter(
      (item) => item > currentSessionSlot.startTime
    );
    setEndTime(temp);
  }, [currentSessionSlot.startTime]);

  useEffect(() => {
    if (session?.startDate && session?.endDate) {
      const _maxNumberOfWeeks = countWeeks(
        new Date(session?.startDate),
        new Date(session?.endDate)
      );

      setMaxNumberOfWeeks(_maxNumberOfWeeks);
    }
  }, [session, currentSessionSlot]);

  const updateSessionValue = (key: any, value: any = "") => {
    setError({ ...errorInit });
    if (typeof key === "object") {
      setSession((oldSession) => ({ ...oldSession, ...key }));
    } else {
      setSession((oldSession) => ({ ...oldSession, [key]: value }));
    }
  };

  const handleAddSlot = () => {
    let { slots } = session;
    slots = _uniqWith(
      [...slots, currentSessionSlot],
      (_slot1: any, _slot2: any) =>
        _slot1?.sessionDay === _slot2?.sessionDay &&
        _slot1?.startTime === _slot2?.startTime &&
        _slot1?.endTime === _slot2?.endTime
    );
    setCurrentSessionSlot({
      sessionDay: "",
      startTime: "",
      endTime: "",
    });
    updateSessionValue("slots", slots);
  };

  const handleDeleteSlot = (_index: number) => {
    let { slots } = session;
    slots = slots?.filter?.((_slot, _idx) => _idx !== _index);
    updateSessionValue("slots", slots);
  };

  const handleAddRule = () => {
    let { rules } = session;
    rules = [
      ...rules,
      {
        subject: "",
        description: "",
      },
    ];
    updateSessionValue("rules", rules);
  };

  const handleAddRates = () => {
    if (rates?.noOfDays && rates?.ratePerSession) {
      if (Number(rates?.ratePerSession) >= 100) {
        setRateError("");
        let { rates: updateRate } = session;
        updateRate = [
          ...updateRate,
          {
            noOfDays: Number(rates.noOfDays),
            ratePerSession: Number(rates.ratePerSession),
          },
        ];
        updateSessionValue("rates", updateRate);
        setRates({
          noOfDays: "",
          ratePerSession: "",
        });
      } else {
        setRateError(getMessage.rate_minLength);
      }
    }
  };

  const handleDeleteRate = (_index: number) => {
    let { rates: rate } = session;
    rate = rate?.filter?.((_rate, _idx) => _idx !== _index);
    updateSessionValue("rates", rate);
  };

  const handleAddOffer = () => {
    if (offers?.discountPercent && offers?.noOfWeeks) {
      let { offers: updateOffer } = session;
      const hasNumberOfWeeks = updateOffer?.find?.(
        (_offer) => Number(_offer?.noOfWeeks) === Number(offers?.noOfWeeks)
      );
      let validation = true;

      if (offers?.discountPercent.toString() == "") {
        validation = false;
        setOffersError({
          noOfWeeks: "",
          discountPercent: getMessage.discountPercent,
        });
      } else if (Number(offers?.noOfWeeks) == 0) {
        validation = false;
        setOffersError({
          discountPercent: "",
          noOfWeeks: getMessage.noOfWeeks,
        });
      } else if (
        Number(offers?.discountPercent) < 0 ||
        Number(offers?.discountPercent) > 100
      ) {
        validation = false;
        setOffersError({
          noOfWeeks: "",
          discountPercent: getMessage.discountPercent_length,
        });
      } else if (numberValidation(Number(offers?.discountPercent)) == null) {
        validation = false;
        setOffersError({
          noOfWeeks: "",
          discountPercent: getMessage.discountPercent_digit,
        });
      }

      if (validation) {
        if (hasNumberOfWeeks) {
          updateOffer = updateOffer?.map?.((_offer) => {
            if (Number(_offer?.noOfWeeks) === Number(offers?.noOfWeeks)) {
              return {
                ..._offer,
                discountPercent: Number(offers?.discountPercent),
              };
            }
            return _offer;
          });
        } else {
          updateOffer = [
            ...updateOffer,
            {
              discountPercent: Number(offers.discountPercent),
              noOfWeeks: Number(offers.noOfWeeks),
            },
          ];
        }
        updateSessionValue("offers", updateOffer);
        setOffers({
          discountPercent: "",
          noOfWeeks: "",
        });
        setOffersError({
          discountPercent: "",
          noOfWeeks: "",
        });
      }
    } else {
      toast.error(getMessage.court_discount);
    }
  };

  const handleDeleteOffer = (_index: number) => {
    let { offers: offer } = session;
    offer = offer?.filter?.((_rate, _idx) => _idx !== _index);
    updateSessionValue("offers", offer);
  };

  const handleRuleChange = (_index: number, value: string) => {
    let { rules } = session;
    rules[_index].subject = value;
    updateSessionValue("rules", rules);
  };

  const handleDeleteRule = (_index: number) => {
    let { rules } = session;
    rules = rules?.filter?.((_rule, _idx) => _idx !== _index);
    updateSessionValue("rules", rules);
  };

  const isValidSession = () => {
    let _isValid = true;

    _isValid = !!(
      session?.name &&
      session?.startDate &&
      session?.slots?.length &&
      session?.courts?.length &&
      session?.sportId &&
      !!session?.rates?.length &&
      session?.coachId &&
      session?.maxNoOfAttendees &&
      Number(session?.maxNoOfAttendees) <= 99999 &&
      session?.minWeeksToBook &&
      SelectedFacility &&
      session?.rates?.sort((a: any, b: any) => a?.noOfDays - b?.noOfDays)[
        session?.rates.length - 1
      ].noOfDays <= session.slots?.length
    );

    if (_isValid) {
      session?.rules?.forEach?.((_rule) => {
        if (!_rule?.subject) {
          _isValid = false;
        }
        if (_rule?.subject.length > 200) {
          _isValid = false;
        }
      });
    }

    return _isValid;
  };

  const handleSubmit = async () => {
    setSubmitButton(true);
    if (isValidSession()) {
      const payload = {
        ...session,
        facilityId: Number(SelectedFacility),
        minWeeksToBook: session?.minWeeksToBook
          ? Number(session?.minWeeksToBook)
          : 0,
        maxNoOfAttendees: session?.maxNoOfAttendees
          ? Number(session?.maxNoOfAttendees)
          : 0,
        startDate: session.startDate
          ? format(new Date(session.startDate), "yyyy-MM-dd")
          : session.startDate,
        endDate: session.endDate
          ? format(new Date(session.endDate), "yyyy-MM-dd")
          : session.endDate,
      };
      const result = await CreateNewSession(payload);
      if (result.status === 200) {
        navigate("/coaching");
      }
      if (result?.response?.data?.message) {
        toast.error(result.response.data.message);
      }
      if (result?.data?.message) {
        toast.success(result.data.message);
      }
    } else {
      let message: any = [];
      session?.rules?.map((_rule: any, index: any) => {
        if (!_rule?.subject) {
          message[index] = getMessage.subject_isNotEmpty;
        }
        if (_rule?.subject.length > 200) {
          message[index] =
            getMessage.subject_length;
        }
      });

      const _error = {
        name: session?.name
          ? session.name.match(/^[a-zA-Z0-9\s\-.@(),/&#]*$/) != null
            ? session.name.length > 30
              ? getMessage.session_maxLength
              : ""
            : getMessage.session_matches
          : getMessage.session_isNotEmpty,
        startDate: session?.startDate ? "" : getMessage.session_startDate,
        slot: session?.slots?.length ? "" : getMessage.session_slot,
        rule: message,
        maxNoOfAttendees: session?.maxNoOfAttendees
          ? session?.maxNoOfAttendees.length > 5
            ? getMessage.session_maximumAttendees
            : ""
          : getMessage.session_maxiIsNotEmpty,
        minWeeksToBook: session?.minWeeksToBook
          ? ""
          : getMessage.minimum_weeks,
        courts: session?.courts?.length ? "" : getMessage.court_required,
        coachId: session?.coachId ? "" : getMessage.court_coachName,
        sportId: session?.sportId ? "" : getMessage.court_sport,
        rates: session?.rates?.length ? "" : getMessage.court_charges,
      };
      if (!SelectedFacility) {
        toast.error(getMessage.facility_isNotEmpty);
      }
      if (
        session?.rates?.sort((a: any, b: any) => a?.noOfDays - b?.noOfDays)[
          session?.rates?.length - 1
        ]?.noOfDays > session.slots?.length
      ) {
        toast.info(
          `Please select ${session?.rates?.sort((a: any, b: any) => a?.noOfDays - b?.noOfDays)[
            session?.rates?.length - 1
          ]?.noOfDays
          } Coaching Session Days.`
        );
      }
      setError({ ..._error });
    }
    setSubmitButton(false);
  };

  const setPositiveValue = (key = "", value = "") => {
    if (validatePositiveValue(value)) {
      updateSessionValue(key, value);
    }
  };

  const getWeekDayOptions = () => {
    return WEEK_DAYS?.filter?.((_day: any) => {
      return !session?.slots?.find?.(
        (_slot: any) => _slot?.sessionDay === _day
      );
    })?.map?.((_day: any) => <option key={_day}>{_day}</option>);
  };

  const options = courtList?.map((item: any) => {
    return {
      labelKey: item.id,
      value: `${item.name}`,
    };
  });

  const handleChange = (value: any) => {
    updateSessionValue("courts", value.selectedKey);
  };

  const getDaysOfWeekBetweenDates = (
    sDate = session.startDate,
    eDate = session.endDate
  ) => {
    const startDate = new Date(sDate);
    const endDate = new Date(eDate);
    endDate.setDate(endDate.getDate());
    const daysOfWeek = [];
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    let i = 0;

    while (i < 7 && startDate < endDate) {
      daysOfWeek.push(dayNames[startDate.getDay()]);
      startDate.setDate(startDate.getDate() + 1);
      i++;
    }

    return daysOfWeek
      ?.filter?.((_day: any) => {
        return !session?.slots?.find?.(
          (_slot: any) => _slot?.sessionDay === _day
        );
      })
      ?.map?.((_day: any) => <option key={_day}>{_day}</option>);
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <Card.Title className="text-start">
              Coaching Session Creation
            </Card.Title>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="selectsport" className="form-label">
                      Select Sport <small className="text-danger">*</small>
                    </label>
                  </div>
                  <DropDown
                    onChange={(e: any) =>
                      updateSessionValue("sportId", Number(e?.target?.value))
                    }
                    value={session?.sportId}
                    className="form-control"
                    id="selectsport"
                    name="selectsport"
                  >
                    <option>Select Sport</option>
                    {AllSportsData?.map?.((_sport) => (
                      <option key={_sport.id} value={_sport?.id}>
                        {_sport?.name}
                      </option>
                    ))}
                  </DropDown>
                  {error?.sportId && (
                    <div className="error-msg">{error?.sportId}</div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="nameofsession" className="form-label">
                      Name the Session <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) =>
                      updateSessionValue("name", e?.target?.value)
                    }
                    value={session?.name}
                    type="text"
                    name="session-name"
                    id="session-name"
                    className="form-control"
                    required={true}
                  />
                  {error?.name && (
                    <div className="error-msg">{error?.name}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="align-items-end mb-3">
              <Col lg={4}>
                <div className="text-start">
                  <label htmlFor="addcharges" className="form-label">
                    Select session per week
                  </label>
                  <DropDown
                    className="form-control"
                    id="addcharges"
                    value={rates?.noOfDays}
                    onChange={(e: any) =>
                      setRates((_oldValue: any) => ({
                        ..._oldValue,
                        noOfDays: e.target.value,
                      }))
                    }
                  >
                    <option>Select session per week</option>
                    {WeekOptions?.filter?.(
                      (_opt: any) =>
                        !session?.rates?.find?.(
                          (_rate: any) => _rate?.noOfDays === _opt?.value
                        )
                    )?.map?.((_opt: any) => (
                      <option key={_opt?.label} value={_opt?.value}>
                        {_opt?.label}
                      </option>
                    ))}
                  </DropDown>
                </div>
              </Col>
              <Col lg={4}>
                <div className="text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="chargesession" className="form-label">
                      Charges Per Session{" "}
                      <small className="text-danger">*</small>
                    </label>
                  </div>
                  <Input
                    onChange={(e: any) => {
                      if (Number(e?.target?.value) >= 0) {
                        if (validatePositiveValue(e.target.value)) {
                          if (
                            /^([0-9]{0,10}|\d)(\.\d{1,2})?$/.test(
                              e.target.value
                            )
                          ) {
                            setRates((_oldValue: any) => ({
                              ..._oldValue,
                              ratePerSession: e.target.value,
                            }));
                          }
                        }
                      }
                    }}
                    value={rates?.ratePerSession}
                    type="number"
                    name="chargesession"
                    id="chargesession"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <div style={{ position: "relative" }}>
                    {rateError && <div className="error-msg" style={{ position: "absolute" }}>{rateError}</div>}
                  </div>
                </div>
              </Col>
              <Col lg={2} className="text-start">
                <Button
                  type="button"
                  bname="Add"
                  name="addcharges"
                  id="addcharges"
                  className="btn btn-primary rounded-1 me-3"
                  onClick={handleAddRates}
                ></Button>
              </Col>
            </Row>
            <Row className="row-mb">
              <Col lg={12}>
                <div className="text-start">
                  <label htmlFor="addedcharges" className="form-label">
                    Added Charges
                  </label>
                  {session?.rates
                    ?.sort((a: any, b: any) => a?.noOfDays - b?.noOfDays)
                    ?.map?.((_rate: any, _index: any) => {
                      const label = WeekOptions?.find?.(
                        (_opt) => _opt?.value === _rate?.noOfDays
                      )?.label;

                      return (
                        <Card
                          key={_rate?.noOfDays}
                          className="bg-light bg-opacity-25 border-left-5 border-light mb-3"
                        >
                          <Card.Body className="align-items-center card-body d-flex justify-content-between p-2">
                            <div className="date-range fw-semibold">
                              {label} -{" "}
                              <span className="rupees-symbol">&#8377;</span>
                              {_rate?.ratePerSession} per session{" "}
                            </div>
                            <Button
                              type="button"
                              bname="Delete"
                              name="deletecharges"
                              id="deletecharges"
                              className="btn btn-sm btn-outline-danger rounded-1"
                              onClick={() => handleDeleteRate(_index)}
                            ></Button>
                          </Card.Body>
                        </Card>
                      );
                    })}
                  {error?.rates && (
                    <div className="error-msg">{error?.rates}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="startdate" className="form-label">
                      Start Date <small className="text-danger">*</small>
                    </label>
                  </div>
                  <DatePicker
                    id="startdate"
                    inputClass="form-control"
                    format="DD/MM/YYYY"
                    containerClassName="custom-container"
                    onChange={(date: any) => {
                      updateSessionValue("minWeeksToBook", "");
                      updateSessionValue(
                        "startDate",
                        date?.toDate().toUTCString()
                      );
                      updateSessionValue("endDate", "");
                    }}
                    value={new Date(session?.startDate)}
                    render={<InputIcon className="form-control" />}
                    minDate={new Date()}
                    editable={false}
                  />
                  {error?.startDate && (
                    <div className="error-msg">{error?.startDate}</div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="enddate" className="form-label">
                    End Date
                  </label>
                  <DatePicker
                    id="enddate"
                    inputClass="form-control"
                    format="DD/MM/YYYY"
                    containerClassName="custom-container"
                    onChange={(date: any) => {
                      updateSessionValue("minWeeksToBook", "");
                      updateSessionValue(
                        "endDate",
                        date?.toDate().toUTCString()
                      );
                    }}
                    value={new Date(session?.endDate)}
                    editable={false}
                    render={<InputIcon className="form-control" />}
                    minDate={
                      session.startDate
                        ? new Date(session.startDate)
                        : new Date()
                    }
                  />
                </div>
              </Col>
            </Row>
            <Row className="align-items-end mb-3">
              <Col lg={4}>
                <div className="text-start">
                  <label htmlFor="selectday" className="form-label">
                    Select Day
                  </label>
                  <DropDown
                    className="form-control"
                    id="sessionDay"
                    name="sessionDay"
                    onChange={(e: any) =>
                      setCurrentSessionSlot((oldSlotValues) => ({
                        ...oldSlotValues,
                        sessionDay: e?.target?.value,
                      }))
                    }
                    value={currentSessionSlot.sessionDay}
                  >
                    <option>Select Day</option>
                    {session.startDate && session.endDate
                      ? getDaysOfWeekBetweenDates()
                      : getWeekDayOptions()}
                  </DropDown>
                </div>
              </Col>
              <Col lg={3}>
                <div className="text-start">
                  <label htmlFor="starttime" className="form-label">
                    Start Time
                  </label>
                  <FormSelect
                    className="form-control"
                    id="startTime"
                    name="startTime"
                    onChange={(e: any) =>
                      setCurrentSessionSlot((oldSlotValues) => ({
                        ...oldSlotValues,
                        startTime: e?.target?.value,
                      }))
                    }
                    value={currentSessionSlot.startTime}
                  >
                    <option value="">Select</option>
                    {TIME_OPTIONS.map((item: any) => {
                      return (
                        <option value={item} key={"startTime" + item}>
                          {item}
                        </option>
                      );
                    })}
                  </FormSelect>
                </div>
              </Col>
              <Col lg={3}>
                <div className="text-start">
                  <label htmlFor="endtime" className="form-label">
                    End Time
                  </label>
                  <FormSelect
                    className="form-control"
                    id="endTime"
                    name="endTime"
                    onChange={(e: any) =>
                      setCurrentSessionSlot((oldSlotValues) => ({
                        ...oldSlotValues,
                        endTime: e?.target?.value,
                      }))
                    }
                    value={currentSessionSlot.endTime}
                    disabled={!currentSessionSlot.startTime}
                  >
                    <option value="">Select</option>
                    {endTime.map((item: any) => {
                      return (
                        <option value={item} key={"endTime" + item}>
                          {item}
                        </option>
                      );
                    })}
                  </FormSelect>
                </div>
              </Col>
              <Col lg={2} className="text-start">
                <Button
                  type="button"
                  bname="Add"
                  name="addmoreday"
                  id="addmoreday"
                  className="btn btn-primary rounded-1 me-3"
                  disabled={
                    !currentSessionSlot.sessionDay ||
                    !currentSessionSlot.startTime ||
                    !currentSessionSlot.endTime
                  }
                  onClick={handleAddSlot}
                ></Button>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="selectendtime" className="form-label">
                      Selected Days ({session.slots?.length}){" "}
                      <small className="text-danger">*</small>
                    </label>
                    {error?.slot && (
                      <div className="custom-error-msg">{error?.slot}</div>
                    )}
                  </div>
                  {session?.slots?.map?.((_slot, _index) => (
                    <div
                      className="bg-light d-inline-block mb-2 me-3 mt-1 rounded-1 p-2 slot-box text-start"
                      style={{ width: "130px" }}
                      key={`Slot_${_slot.sessionDay}_${_slot.startTime}_${_slot.endTime}_${_index}`}
                    >
                      <span className="d-block">{_slot?.sessionDay}</span>
                      <span className="text-primary">
                        {_slot?.startTime} to {_slot?.endTime}
                      </span>
                      <img
                        onClick={handleDeleteSlot.bind(this, _index)}
                        src={images.deletesport.default}
                        width="19"
                        alt=""
                      />
                    </div>
                  ))}
                </div>
              </Col>
              <hr />
            </Row>
            <Row className="align-items-end mb-3">
              <Col lg={3}>
                <div className="text-start">
                  <label htmlFor="add-discount" className="form-label">
                    Add Discount (%)
                  </label>
                  <Input
                    type="number"
                    name="add-discount"
                    id="add-discount"
                    className="form-control"
                    value={offers?.discountPercent}
                    onChange={(e: any) => {
                      if (
                        (validatePositiveValue(e.target.value) &&
                          Number(e.target.value) <= 100 &&
                          Number(e.target.value) >= 1) ||
                        !e.target.value
                      ) {
                        setOffers((_oldValue: any) => ({
                          ..._oldValue,
                          discountPercent: e.target.value,
                        }));
                      }
                    }}
                    onKeyDown={(e: any) => e.key === "e" && e.preventDefault()}
                  />
                </div>
                {offersError?.discountPercent && (
                  <div className="error-msg">
                    {offersError?.discountPercent}
                  </div>
                )}

              </Col>
              <Col lg={3}>
                <div className="text-start">
                  <label htmlFor="weeks" className="form-label">
                    Add Weeks For Booking
                  </label>
                  <div
                    style={{ display: "flex", gap: 5, alignItems: "center" }}
                  >
                    <Input
                      type="text"
                      name="add-discount"
                      id="add-discount"
                      className="form-control"
                      value={offers?.noOfWeeks}
                      onChange={(e: any) => {
                        if (maxNumberOfWeeks == null) {
                          toast.error(getMessage.startDate_endDate_isNotEmpty);
                        } else {
                          if (
                            maxNumberOfWeeks &&
                            e.target.value > maxNumberOfWeeks
                          ) {
                            toast.error(
                              `As per selected slots, offer for weeks can not be greater than ${maxNumberOfWeeks}`
                            );
                          } else {
                            if (validatePositiveValue(e.target.value)) {
                              setOffers((_oldValue: any) => ({
                                ..._oldValue,
                                noOfWeeks: e.target.value,
                              }));
                            }
                          }
                        }
                      }}
                      onKeyDown={(e: any) =>
                        (e.key === "e" || e.key === ".") && e.preventDefault()
                      }
                    />
                  </div>
                </div>
                {offersError?.discountPercent && (
                  <div className="error-msg">{offersError?.noOfWeeks}</div>
                )}
              </Col>
              <Col lg={2} className="text-start">
                <Button
                  type="button"
                  bname="Add"
                  name="add-discountbtn"
                  id="add-discountbtn"
                  className="btn btn-primary rounded-1 me-3"
                  onClick={handleAddOffer}
                ></Button>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="text-start">
                  <label htmlFor="added-discount" className="form-label">
                    Added Discount
                  </label>
                  {session?.offers?.map?.((_offer, _index) => (
                    <Card
                      key={_offer?.noOfWeeks}
                      className="bg-opacity-25 bg-opacity-50 bg-success border-left-5 border-success card mb-3"
                    >
                      <Card.Body className="align-items-center card-body d-flex justify-content-between p-2">
                        <div className="date-range fw-semibold">
                          {_offer?.discountPercent}% Discount added for{" "}
                          {_offer?.noOfWeeks} weeks
                        </div>
                        <Button
                          type="button"
                          bname="Delete"
                          name="deletediscount"
                          id="deletediscount"
                          className="btn btn-danger btn-sm rounded-1"
                          onClick={() => handleDeleteOffer(_index)}
                        ></Button>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="minimumweekstobook" className="form-label">
                    Min number of Weeks to book{" "}
                    <small className="text-danger">*</small>
                  </label>
                  <Input
                    onChange={(e: any) => {
                      if (maxNumberOfWeeks == null) {
                        toast.error(getMessage.startDate_endDate_isNotEmpty);
                      } else {
                        if (
                          maxNumberOfWeeks &&
                          e.target.value > maxNumberOfWeeks
                        ) {
                          toast.error(
                            `As per selected slots, minimum number of weeks can not be greater than ${maxNumberOfWeeks}`
                          );
                        } else {
                          setPositiveValue("minWeeksToBook", e?.target?.value);
                        }
                      }
                    }}
                    value={session?.minWeeksToBook}
                    type="text"
                    name="minimumweekstobook"
                    id="minimumweekstobook"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      (e.key === "e" || e.key === ".") && e.preventDefault()
                    }
                  />
                  {error?.minWeeksToBook && (
                    <div className="error-msg">{error?.minWeeksToBook}</div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="maximumattendees" className="form-label">
                    Max number of Attendees <small>(Per Session)</small>{" "}
                    <small className="text-danger">*</small>
                  </label>
                  <Input
                    onChange={(e: any) =>
                      setPositiveValue("maxNoOfAttendees", e?.target?.value)
                    }
                    value={session?.maxNoOfAttendees}
                    type="text"
                    name="maximumattendees"
                    id="maximumattendees"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      (e.key === "e" || e.key === ".") && e.preventDefault()
                    }
                  />
                  {error?.maxNoOfAttendees && (
                    <div className="error-msg">{error?.maxNoOfAttendees}</div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="coachname" className="form-label">
                      Select Coach Name <small className="text-danger">*</small>
                    </label>
                  </div>
                  <DropDown
                    className="form-control"
                    id="coachId"
                    name="coachId"
                    onChange={(e: any) =>
                      updateSessionValue("coachId", Number(e?.target?.value))
                    }
                    value={session?.coachId}
                  >
                    <option>Select Coach </option>
                    {AllCoachesData?.map?.((_coach) => (
                      <option key={_coach?.id} value={_coach?.id}>
                        {_coach?.fullName}
                      </option>
                    ))}
                  </DropDown>
                  {error?.coachId && (
                    <div className="error-msg">{error?.coachId}</div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <div className="custom-label-layout">
                    <label htmlFor="assigncourt" className="form-label">
                      Assign Court <small className="text-danger">*</small>
                    </label>
                  </div>
                  <BootstrapSelect
                    className="form-select-custom form-control"
                    selectStyle=""
                    actionBtnStyle="btn-outline-primary"
                    options={options}
                    isMultiSelect={true}
                    showTick={true}
                    showAction={true}
                    placeholder="Select Court"
                    onChange={handleChange}
                  />
                  {error?.courts && (
                    <div className="error-msg">{error?.courts}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Row></Row>
            <div className="custom-label-layout">
              <label htmlFor="selectendtime" className="form-label">
                Rules <small className="text-danger">*</small>
              </label>
            </div>
            {session?.rules?.map?.((_rule, _index) => (
              <div
                className="border rounded-1 sports-field "
                key={`Rule_${_index}`}
                style={{ marginTop: 0, marginBottom: "1.875rem" }}
              >
                <Row className="align-items-center g-0">
                  <Col lg={2}>
                    <h4 className="text-center">Rule {Number(_index) + 1}</h4>
                  </Col>
                  <Col lg={10}>
                    <div className="sports-detail">
                      <div className="mb-3 text-start">
                        <label htmlFor="subjectrule" className="form-label">
                          Subject of Rule{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter Subject of Rule"
                          id="subjectrule"
                          name="subjectrule"
                          className="form-control"
                          onChange={(e: any) =>
                            handleRuleChange(_index, e?.target?.value)
                          }
                          value={_rule?.subject}
                        />
                        {error?.rule && (
                          <div className="error-msg">{error?.rule[_index]}</div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
                {_index !== 0 && (
                  <img
                    src={images.deletesport.default}
                    className="delete-sport"
                    alt="Delete Sport"
                    onClick={handleDeleteRule.bind(this, _index)}
                  />
                )}
              </div>
            ))}
            <Row>
              <Col lg={12} className="text-end">
                <Button
                  type="button"
                  bname={session?.rules?.length ? "Add Rule" : "Add Rules"}
                  name="addmore"
                  id="addmore"
                  className="btn btn-primary rounded-1"
                  onClick={handleAddRule}
                ></Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col lg={12} className="text-end mt-3">
                <Button
                  disalbed={submitButton.toString()}
                  type="button"
                  bname={submitButton ? "Creating Session" : "Create Session"}
                  name="createsession"
                  id="createsession"
                  className="btn btn-primary rounded-1"
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { CreateSession };
